"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const v4_1 = require("zod/v4");
exports.artifactType = 'borrowingBaseReport';
// Intermediate config schema
exports.IntermediateNodeConfigSchema = v4_1.z
    .object({
    operationDescription: v4_1.z
        .string()
        .optional()
        .describe('Deprecated: not generated by tape-builder but retained for backwards compatibility'),
    tapeDescription: v4_1.z.string().describe('Description shown in the tape node'),
    createServicerReport: v4_1.z
        .boolean()
        .optional()
        .describe('Whether to generate a servicer report'),
    fundingSubmissionArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Slug for funding submission components artifact'),
    extendedResponseTapeUploads: v4_1.z
        .array(v4_1.z
        .object({
        loanProductSlug: v4_1.z.string(),
        uploadPath: v4_1.z.string(),
    })
        .describe('Upload settings for each extended response tape (per loan product)'))
        .optional(),
})
    .describe('Intermediate node configuration');
// Intermediate node schema
exports.IntermediateNodeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    loanProductSlug: v4_1.z.string().nullable(),
    creditFacilitySlug: v4_1.z.string().nullable(),
    configuration: exports.IntermediateNodeConfigSchema,
});
// DB config schema (extends intermediate)
exports.NodeConfigSchema = exports.IntermediateNodeConfigSchema.extend({
    receivableResponseTapeArtifactSlug: v4_1.z
        .string()
        .describe('Slug for receivable response tape artifact'),
    cashBalancesFeedContextArtifactSlug: v4_1.z
        .string()
        .nullable()
        .optional()
        .describe('Optional slug for cash balances feed context artifact'),
    cashResponseTapeArtifactSlug: v4_1.z
        .string()
        .nullable()
        .optional()
        .describe('Optional slug for cash response tape artifact'),
}).describe('DB node configuration');
// Full node schema
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    creditFacilitySlug: v4_1.z.string(),
    loanProductSlug: v4_1.z.null(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map